export default {
  strict: true,
  namespaced: true,
  state: {
    creditCards: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20
    }
  },
  mutations: {
    resetCards (state) {
      state.creditCards.list = []
    },
    addCards (state, value) {
      state.creditCards.list.push(value)
    },
    setCardsIsMax (state, value) {
      state.creditCards.isMax = value
    },
    setCardsCurrentPage (state, value) {
      state.creditCards.currentPage = value
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/consumer/credit-cards.js